// import router from '@/app/router';
//
// const goBack = (route) => {
//   router.push({
//     name: 'dashboard',
//     query: route.query
//   });
// };

export default {
  default: {
    component: () => import(/* webpackChunkName: 'shared/sharedLink' */ './SharedLink'),
    routes: [
      {
        path: '',
        name: 'shared-link',
        component: () => import(/* webpackChunkName: 'shared/sharedLinkMain' */ './components/SharedLinkMain')
      }
    ]
  }
};
